module.exports = __webpack_public_path__ + "img/pic3.972a37d1.png";